// @flow
import api from 'tim-api';
import { user as userEndPont, userWithSale } from 'endPoints';
import hasPermission from '../globalFunctions/hasPermission';

export const state = {
  users: [],
  usersWithSale: [],
  pagination: {},
  views: [],
  channels: []
};

export const getters = {
  users: (state: Object) => state.users,
  usersWithSale: (state: Object) => state.usersWithSale,
  userByCpf: (state: Object) => (cpf: string) => state.users.find((user: Object) => user.cpf === cpf),
  pagination: (state: Object) => state.pagination,
  views: (state: Object) => state.views,
  channels: (state: Object) => state.channels
};

export const mutations = {
  SET_USERS(state: Object, users: Array<Object>) {
    state.users = users;
  },
  SET_USERS_WITH_SALES(state: Object, usersWithSale: Array<Object>) {
    state.usersWithSale = usersWithSale;
  },
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_VIEWS(state: Object, views: Object) {
    state.views = views;
  },
  SET_CHANNELS(state: Object, channels: Object) {
    state.channels = channels;
  }
};

export const actions = {
  fetchUsers({ commit }: Action, { page, search, sort }: Object) {
    commit('SET_USERS', []);

    let url = '';

    if (hasPermission('web.distribuidor.acesso') && search) {
      url = `sigtim/users/search/${search}?page=${page || 1}`;
    } else if (hasPermission('web.distribuidor.acesso')) {
      url = `${userEndPont}?page=${page || 1}`;
    } else if (search) {
      url = `${userEndPont}/search/${search}?page=${page || 1}`;
    } else {
      url = `${userEndPont}?page=${page || 1}`;
    }

    if (sort) {
      url += `&order=${sort.order}&sort=${sort.sort}`;
    }

    return api.get(url).then(({ data }) => {
      commit('SET_USERS', search ? data.data.data : data.data);
      commit('SET_PAGINATION', {
        current_page: search ? data.data.current_page : data.current_page,
        first_page_url: search ? data.data.first_page_url : data.first_page_url,
        from: search ? data.data.from : data.from,
        last_page: search ? data.data.last_page : data.last_page,
        last_page_url: search ? data.data.last_page_url : data.last_page_url,
        next_page_url: search ? data.data.next_page_url : data.next_page_url,
        path: search ? data.data.path : data.path,
        per_page: search ? data.data.per_page : data.per_page,
        prev_page_url: search ? data.data.prev_page_url : data.prev_page_url,
        total: search ? data.data.total : data.total
      });
    });
  },
  fetchUserByCpf({ commit }: Action, cpf: string) {
    return api.post(`${userEndPont}/cpf`, { 'cpf': cpf }).then(({ data }) => {
      commit('SET_USERS', [data.data]);
    });
  },

  fetchSigTimViews({ commit }: Action) {
    const url = 'view/sigtim/';
    api.get(url).then(({ data }) => {
      commit('SET_VIEWS', data.data);
    });
  },
  fetchSigTimChannels({ commit }: Action) {
    const url = 'sigtim/channels/';
    api.get(url).then(({ data }) => {
      commit('SET_CHANNELS', data.data);
    });
  },
  fetchUsersWithSale({ commit }: Object) {
    return api.get(`${userWithSale}`).then(({ data }) => {
      commit('SET_USERS_WITH_SALES', data.data);
    });
  },

  // eslint-disable-next-line
  update({ commit }: Action, { user, cpf }: Object) {
    return api.put(`${userEndPont}/${cpf}`, user);
  },

  // eslint-disable-next-line
  create({ commit }: Action, { user, cpf }: Object) {
    return api.post(`${userEndPont}`, user);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
